import "./midbanner.css";
import config from "../../config";
const Midbanner = () => {
  return (
    <section class="second-mid-banner-section">
      <div class="container">
        <div class="second-mid-banner-section-wrapper">
          <h2>Turn Oversight into Orchestration</h2>
          <p>
            Move beyond static monitoring — govern AI with intelligence.
            AgentGRC.ai brings real-time compliance, policy enforcement, and
            lifecycle governance into a single adaptive system.
          </p>
          <a href={config.bookdemo.Link}>
            <div class="second-mid-banner-button">
              <p>Get Started Today</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Midbanner;
